import { _ } from "libs";
import React, { memo } from "react";
import Select from "../../select";
import { SelectValue } from "../../../types";

function createlanguages(): SelectValue[] {
	return [
		{ value: "en", label: _("language.en") },
		{ value: "de", label: _("language.de") },
		{ value: "it", label: _("language.it") },
		{ value: "fr", label: _("language.fr") },
		{ value: "es", label: _("language.es") },
	];
}

const LanguageSelect = ({ input: { onChange, value, name }, prompt = null, ...rest }) => {
	const languages = createlanguages();
	return (
		<div className="select language">
			<Select prompt={prompt} items={languages} value={value} onChange={onChange} />
			<div className="icon" />
		</div>
	);
};

export default memo(LanguageSelect);
